<script>
    import { onMount } from "svelte";
    import * as api from "../utiles/api";
    import { push } from "svelte-spa-router";
    import Btm from "../components/Btm.svelte";
    import * as store from "../stores/store";
    import { get } from "svelte/store";
    import { selectedAs } from "../stores/store";

    export let params;

    let as_id = params.as_id;
    let selectedAsInfo = get(selectedAs);

    let pageSize = 10; // 한 번에 로드할 데이터 개수
    let currentPage = 0; // 현재 페이지
    let currentList = [];
    let dataList = [];

    let activeIndex = null;

    function handleClick(index) {
        if (activeIndex === index) {
            // 이미 선택된 항목이면 해제
            activeIndex = null;
        } else {
            activeIndex = index;
        }
    }

    // 버튼 배경 색 결정
    $: btnBackground =
        activeIndex !== null
            ? "var(--Color-on, #4E8EED)"
            : "var(--Color-line, #E4E8EA)";

    onMount(() => {
        getData();
    });

    async function getData() {
        currentPage = 0;
        currentList = [];

        const response = await api.get(
            `/partner?keyword=&page=1&sort=${decodeURI(
                "a.created_at DESC",
            )}&cate=&usePageNavy=false`,
        );

        if (response != null) {
            dataList = [];
            dataList = response.data;
            loadMore(); // 초기 데이터 로드
        }
    }

    function loadMore() {
        const start = currentPage * pageSize;
        const end = start + pageSize;

        currentList = [...currentList, ...dataList.slice(start, end)];
        currentPage++;
    }

    function handleScroll(event) {
        const { scrollTop, scrollHeight, clientHeight } = event.target;

        if (scrollTop + clientHeight >= scrollHeight - 10) {
            if (currentList.length < dataList.length) {
                loadMore();
            }
        }
    }

    async function saveClick() {
        const formData = {
            as_id,
            as_cmpn_id: activeIndex,
            repair_id: 0,
        };

        const response = await api.post("/assignment/put", formData);

        if (response != null) {
            if (Capacitor.isNativePlatform()) {
            }
            push("/AsTimeComplete");
        } else {
            alert(response.msg);
        }
    }
</script>

<!-- svelte-ignore a11y-click-events-have-key-events -->
<!-- svelte-ignore a11y-missing-attribute -->
<div class="main-body custom-partner">
    <div class="main-content">
        <header class="as-header">
            <button class="back-btn" on:click={() => window.history.back()}>
                <svg
                    viewBox="0 0 24 24"
                    width="24"
                    height="24"
                    stroke="currentColor"
                    stroke-width="2"
                    fill="none"
                >
                    <polyline points="15 18 9 12 15 6"></polyline>
                </svg>
            </button>
            <h1>업체 배정</h1>
        </header>

        <div class="as-list-container scroll-custom" on:scroll={handleScroll}>
            <!-- 선택된 AS 정보 요약 카드 -->
            {#if selectedAsInfo}
                <div class="selected-as-summary">
                    <div class="summary-header">
                        <span class="summary-tag">선택된 접수 정보</span>
                    </div>
                    <div class="summary-body">
                        <div class="summary-row">
                            <span class="s-label">접수처/수리처</span>
                            <span class="s-value">
                                {$selectedAs?.cus_name?.replaceAll(
                                    "<br>",
                                    " / ",
                                ) || ""}
                            </span>
                        </div>
                        <div class="summary-row">
                            <span class="s-label">제품명</span>
                            <span class="s-value">
                                {$selectedAs?.item_name || ""}
                            </span>
                        </div>
                    </div>
                </div>
            {/if}

            <div class="list-title">배정할 업체 선택</div>

            {#each currentList as data, index}
                <div
                    class="as-card-item {activeIndex === data.cmpn_id
                        ? 'selected'
                        : ''}"
                    on:click={() => handleClick(data.cmpn_id)}
                >
                    <div class="as-card-header">
                        <span class="as-driver-name">{data.name}</span>
                        {#if activeIndex === data.cmpn_id}
                            <span class="as-select-badge">선택됨</span>
                        {/if}
                    </div>

                    <div class="as-card-body">
                        <div class="as-info-row">
                            <span class="as-label">연락처</span>
                            <span class="as-value">{data.tel}</span>
                        </div>
                        <div class="as-info-row">
                            <span class="as-label">주소</span>
                            <span class="as-value as-address">
                                {(
                                    data.addr1 || "" + " " + (data.addr2 || "")
                                ).trim() || "-"}
                            </span>
                        </div>
                    </div>
                </div>
            {/each}
        </div>

        <div class="as-action-container">
            <button
                class="as-submit-btn"
                class:disabled={activeIndex === null}
                on:click={() => {
                    if (activeIndex != null) {
                        if (activeIndex == get(store.accountInfo).cmpn_id) {
                            push(`/AsRepair/${as_id}/${activeIndex}`);
                        } else {
                            saveClick();
                        }
                    }
                }}
            >
                <span>기사 배정</span>
                <svg
                    class="as-btn-icon"
                    viewBox="0 0 24 24"
                    width="20"
                    height="20"
                    stroke="currentColor"
                    stroke-width="3"
                    fill="none"
                >
                    <line x1="5" y1="12" x2="19" y2="12"></line>
                    <polyline points="12 5 19 12 12 19"></polyline>
                </svg>
            </button>
        </div>

        <Btm />
    </div>
</div>

<style>
    .custom-partner.main-body {
        background-color: var(--bg-primary) !important;
        min-height: 100vh;
    }
    .custom-partner .main-content {
        max-width: 1024px;
        margin: 0 auto;
        height: 100vh;
        display: flex;
        flex-direction: column;
        background-color: var(--bg-primary);
    }

    .custom-partner .as-header {
        background-color: var(--bg-secondary);
        padding: 18px 16px;
        display: flex;
        align-items: center;
        gap: 16px;
        border-bottom: 1px solid var(--border-color);
        position: sticky;
        top: 0;
        z-index: 100;
    }
    .custom-partner .back-btn {
        background: none;
        border: none;
        color: var(--text-primary);
        cursor: pointer;
        padding: 4px;
        display: flex;
        align-items: center;
    }
    .custom-partner h1 {
        font-size: 18px;
        font-weight: 700;
        color: var(--text-primary);
        margin: 0;
    }

    /* 선택된 AS 정보 요약 */
    .custom-partner .selected-as-summary {
        background-color: var(--color-primary-light);
        border-radius: 12px;
        padding: 16px;
        margin-bottom: 24px;
        border: 1px solid var(--color-primary);
    }
    .custom-partner .summary-tag {
        font-size: 11px;
        font-weight: 800;
        color: var(--color-primary);
        text-transform: uppercase;
        letter-spacing: 0.5px;
        margin-bottom: 8px;
        display: inline-block;
    }
    .custom-partner .summary-row {
        display: flex;
        margin-bottom: 4px;
    }
    .custom-partner .s-label {
        font-size: 13px;
        color: var(--text-secondary);
        width: 100px;
        flex-shrink: 0;
    }
    .custom-partner .s-value {
        font-size: 14px;
        font-weight: 700;
        color: var(--text-primary);
    }

    .custom-partner .list-title {
        font-size: 15px;
        font-weight: 700;
        color: var(--text-primary);
        margin-bottom: 12px;
        padding-left: 4px;
    }

    /* List Container */
    .custom-partner .as-list-container {
        flex: 1;
        overflow-y: auto;
        padding: 16px;
        /* 버튼과 하단 바 높이를 고려하여 여백 대폭 확대 */
        padding-bottom: 180px;
    }

    /* Driver Card */
    .custom-partner .as-card-item {
        background-color: var(--bg-secondary);
        border-radius: 12px;
        box-shadow: var(--shadow-sm);
        margin-bottom: 12px;
        overflow: hidden;
        border: 2px solid var(--border-color);
        transition: all 0.2s;
        cursor: pointer;
    }
    .custom-partner .as-card-item.selected {
        border-color: var(--color-primary);
        background-color: var(--bg-secondary);
        box-shadow: 0 4px 12px rgba(59, 130, 246, 0.15);
    }

    .custom-partner .as-card-header {
        padding: 12px 16px;
        background-color: var(--bg-tertiary);
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-bottom: 1px solid var(--border-color);
    }
    .custom-partner .as-card-item.selected .as-card-header {
        background-color: var(--color-primary-light);
        border-bottom-color: var(--color-primary);
    }

    .custom-partner .as-driver-name {
        font-size: 15px;
        font-weight: 700;
        color: var(--text-primary);
    }
    .custom-partner .as-select-badge {
        font-size: 11px;
        font-weight: 800;
        background-color: var(--color-primary);
        color: white;
        padding: 2px 8px;
        border-radius: 4px;
    }

    .custom-partner .as-card-body {
        padding: 14px 16px;
    }
    .custom-partner .as-info-row {
        display: flex;
        margin-bottom: 6px;
        font-size: 14px;
        align-items: flex-start;
    }
    .custom-partner .as-label {
        width: 70px;
        color: var(--text-tertiary);
        font-weight: 500;
        font-size: 13px;
        flex-shrink: 0;
    }
    .custom-partner .as-value {
        flex: 1;
        color: var(--text-primary);
        word-break: break-all;
    }
    .custom-partner .as-address {
        line-height: 1.4;
    }

    /* Action Button Container - Glassmorphism */
    .custom-partner .as-action-container {
        position: fixed;
        bottom: 70px;
        left: 0;
        right: 0;
        padding: 24px 20px 40px;
        max-width: 1024px;
        margin: 0 auto;
        z-index: 100;
        background: linear-gradient(to top, var(--bg-primary) 90%, transparent);
        backdrop-filter: blur(8px);
        -webkit-backdrop-filter: blur(8px);
    }

    .custom-partner .as-submit-btn {
        width: 100%;
        height: 60px;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 12px;
        background: linear-gradient(135deg, #1e40af 0%, #3b82f6 100%);
        color: white;
        border: none;
        border-radius: 16px;
        font-size: 18px;
        font-weight: 800;
        cursor: pointer;
        position: relative;
        overflow: hidden;
        /* 강력한 글로우 효과 */
        box-shadow: 0 10px 30px -5px rgba(59, 130, 246, 0.5);
        transition: all 0.4s cubic-bezier(0.23, 1, 0.32, 1);
    }

    .custom-partner .as-submit-btn::before {
        content: "";
        position: absolute;
        top: 0;
        left: -100%;
        width: 100%;
        height: 100%;
        background: linear-gradient(
            90deg,
            transparent,
            rgba(255, 255, 255, 0.2),
            transparent
        );
        transition: 0.5s;
    }

    .custom-partner .as-submit-btn:hover:not(.disabled) {
        transform: translateY(-4px);
        box-shadow: 0 15px 40px -5px rgba(59, 130, 246, 0.6);
    }

    .custom-partner .as-submit-btn:hover:not(.disabled)::before {
        left: 100%;
    }

    .custom-partner .as-submit-btn:active:not(.disabled) {
        transform: translateY(0) scale(0.97);
    }

    .custom-partner .as-submit-btn.disabled {
        background: #94a3b8;
        box-shadow: none;
        cursor: not-allowed;
        opacity: 0.6;
    }

    .custom-partner .as-btn-icon {
        transition: transform 0.3s ease;
    }

    .custom-partner .as-submit-btn:hover:not(.disabled) .as-btn-icon {
        transform: translateX(5px);
    }
    .custom-partner .as-submit-btn:hover:not(:disabled) {
        transform: translateY(-2px);
        filter: brightness(1.1);
    }
    .custom-partner .as-submit-btn:active {
        transform: scale(0.98);
    }
    .custom-partner .as-submit-btn:disabled {
        background: var(--border-color) !important;
        box-shadow: none;
        cursor: not-allowed;
        color: var(--text-tertiary);
    }
</style>
